import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StackedBarChart from '../components/stacked-bar-chart';
import PeriodDropdown from '../components/period-dropdown';
import { aggregateAnnualDataForBar } from './chart-helper';
import { getUserRoleColorFromKey } from '../../../../../util/helpers';

const initialPeriod = 12;

class UserChart extends Component {
  constructor(props) {
    super(props);

    const { data, timestamps } = props.data;

    this.state = {
      data: data.map((typeData) => typeData.slice(-initialPeriod)),
      timestamps: timestamps.slice(-initialPeriod),
      period: 'monthly',
    };

    this.handlePeriodChange = this.handlePeriodChange.bind(this);
  }

  handlePeriodChange(value) {
    const period = value;

    let data = [];
    let timestamps = [];

    switch (period) {
      case 'monthly':
        data = this.props.data.data.map((typeData) => typeData.slice(-initialPeriod));
        timestamps = this.props.data.timestamps.slice(-initialPeriod);
        break;
      case 'annual':
        const aggregated = aggregateAnnualDataForBar(this.props.data.data, this.props.data.timestamps);
        data = aggregated.data;
        timestamps = aggregated.timestamps;
        break;
      default:
        data = this.props.data.data.map((typeData) => typeData.slice(-initialPeriod));
        timestamps = this.props.data.timestamps.slice(-initialPeriod);
        break;
    }

    this.setState({ period: period.toString(), data, timestamps });
  }

  render() {
    const seriesNames = this.props.data.categories;
    const colors = ['admin', 'manager', 'salesrep'].map(key => getUserRoleColorFromKey(key));

    return (
      <div>
        <h5 className="sub-header-with-controls">
          {"View Number of Unique Users By "}
          <PeriodDropdown
            period={this.state.period}
            handlePeriodChange={this.handlePeriodChange}
          />
          {" Periods"}
        </h5>
        <StackedBarChart
          data={this.state.data}
          xAxisData={this.state.timestamps}
          seriesNames={seriesNames}
          colors={colors}
        />
      </div>
    );
  }
}

UserChart.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    timestamps: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  }).isRequired,
};

export default UserChart;
